import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import ApartmentCard from "../components/ApartmentCard";
import { fetchApartments } from "../lib/api";
import { Loader2 } from "lucide-react";

export default function Portfolio() {
  const [apartments, setApartments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchApartments()
      .then(setApartments)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="apartments-page" className="pb-32">
      <section className="container-luxe pb-12 pt-16 md:pt-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="mx-auto max-w-3xl text-center"
        >
          <span className="overline">Managed Portfolio</span>
          <h1 className="mt-5 font-[Cormorant_Garamond] text-5xl text-[#1A1D1A] md:text-6xl">
            Case studies from the practice
          </h1>
          <div className="gold-divider mt-6" />
          <p className="mt-7 text-base leading-relaxed text-[#4A524C] md:text-lg">
            Each residence below is privately owned and managed by Sagita
            Rasmadi under a bespoke consulting mandate. We do not aggregate or
            resell inventory — every property has an owner, a brief, and a
            written scope of work.
          </p>
        </motion.div>
      </section>

      <section className="container-luxe">
        {loading ? (
          <div className="flex justify-center py-24">
            <Loader2 className="animate-spin text-[#7A8C7B]" />
          </div>
        ) : (
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {apartments.map((apt, i) => (
              <ApartmentCard key={apt.id} apartment={apt} index={i} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
